import React from "react";
import { FocusCaptureProperty } from "../../../Model/CaptureProfile";
import "./AutoFocusOptions.css";
import DefaultImagingSettingTextBox from "./DefaultImagingSettingTextBox";

const MAX_FOCUS_LEVELS_ABOVE = "maxFocusLevelsAbove";
const MAX_FOCUS_LEVELS_BELOW = "maxFocusLevelsBelow";
const FOCUS_THRESHOLD_ABOVE = "focusThresholdAbove";
const FOCUS_THRESHOLD_BELOW = "focusThresholdBelow";
const MIN_AUTO_FOCUS_STEP_SIZE = "minAutoFocusStepSize";

type Props = {
  style: React.CSSProperties;
  focusCaptureProperty: FocusCaptureProperty;
  onChange: (focusCaptureProperty: FocusCaptureProperty) => void;
  onErrorOccur: (key: string) => void;
  onErrorCleared: (key: string) => void;
};

export default function AutoFocusOptions({ style, focusCaptureProperty, onChange, onErrorOccur, onErrorCleared }: Props) {
  const autoFocusCaptureProperty = focusCaptureProperty.autoFocus;
  return (
    <div
      className="auto-focus-options"
      style={{
        ...style,
      }}
    >
      <DefaultImagingSettingTextBox
        value={autoFocusCaptureProperty.maxFocusLevelsAbove}
        onChange={(name, value) =>
          onChange({ ...focusCaptureProperty, autoFocus: { ...autoFocusCaptureProperty, maxFocusLevelsAbove: value } })
        }
        label="Max. Focus Level Above"
        name={MAX_FOCUS_LEVELS_ABOVE}
        unit=""
        style={{
          gridArea: MAX_FOCUS_LEVELS_ABOVE,
        }}
        isInteger={true}
        disabled={false}
        min={1}
        max={100}
        onErrorOccur={(name) => onErrorOccur(name)}
        onErrorCleared={(name) => onErrorCleared(name)}
      />

      <DefaultImagingSettingTextBox
        value={autoFocusCaptureProperty.maxFocusLevelsBelow}
        onChange={(name, value) =>
          onChange({ ...focusCaptureProperty, autoFocus: { ...autoFocusCaptureProperty, maxFocusLevelsBelow: value } })
        }
        label="Max. Focus Level Below"
        name={MAX_FOCUS_LEVELS_ABOVE}
        unit=""
        style={{
          gridArea: MAX_FOCUS_LEVELS_BELOW,
        }}
        isInteger={true}
        disabled={false}
        min={1}
        max={100}
        onErrorOccur={(name) => onErrorOccur(name)}
        onErrorCleared={(name) => onErrorCleared(name)}
      />

      <DefaultImagingSettingTextBox
        value={autoFocusCaptureProperty.focusThresholdAbove}
        onChange={(name, value) =>
          onChange({ ...focusCaptureProperty, autoFocus: { ...autoFocusCaptureProperty, focusThresholdAbove: value } })
        }
        label="Focus Threshold Above"
        name={FOCUS_THRESHOLD_ABOVE}
        unit=""
        style={{
          gridArea: FOCUS_THRESHOLD_ABOVE,
        }}
        isInteger={false}
        disabled={false}
        min={0.1}
        max={1}
        onErrorOccur={(name) => onErrorOccur(name)}
        onErrorCleared={(name) => onErrorCleared(name)}
      />

      <DefaultImagingSettingTextBox
        value={autoFocusCaptureProperty.focusThresholdBelow}
        onChange={(name, value) =>
          onChange({ ...focusCaptureProperty, autoFocus: { ...autoFocusCaptureProperty, focusThresholdBelow: value } })
        }
        label="Focus Threshold Below"
        name={FOCUS_THRESHOLD_BELOW}
        unit=""
        style={{
          gridArea: FOCUS_THRESHOLD_BELOW,
        }}
        isInteger={false}
        disabled={false}
        min={0.1}
        max={1}
        onErrorOccur={(name) => onErrorOccur(name)}
        onErrorCleared={(name) => onErrorCleared(name)}
      />

      <DefaultImagingSettingTextBox
        value={focusCaptureProperty.minAutoFocusStepSize}
        onChange={(name, value) => onChange({ ...focusCaptureProperty, minAutoFocusStepSize: value })}
        label="Min. Step Size"
        name={MIN_AUTO_FOCUS_STEP_SIZE}
        unit="mm"
        style={{
          gridArea: MIN_AUTO_FOCUS_STEP_SIZE,
        }}
        isInteger={false}
        disabled={false}
        min={0.001}
        max={1}
        onErrorOccur={(name) => onErrorOccur(name)}
        onErrorCleared={(name) => onErrorCleared(name)}
      />
    </div>
  );
}
